import { API_BASE_URL } from '../../config/api';
import apiCache, { CACHE_TTL } from '../../lib/apiCache';

const CACHE_KEY = 'giraInfantil';

const GiraInfData = {
    fetch: async () => {
        const cached = apiCache.get(CACHE_KEY);
        if (cached !== undefined) return cached;

        try {
            const response = await fetch(`${API_BASE_URL}/api/girainfantil`);
            const data = await response.json();

            if (!response.ok || data.message === "No hay giras vigentes" || data.gira == null) {
                const empty = { message: "No hay giras vigentes" };
                return apiCache.set(CACHE_KEY, empty, CACHE_TTL.LIST);
            }

            // If data is a single object, wrap it in an array
            const giraArray = Array.isArray(data) ? data : [data];

            const result = giraArray
                .filter((gira) => gira && gira.gira != null)
                .map(gira => ({
                gira: gira.gira,
                etapas: gira.etapas,
                nombre: gira.nombre,
                inicio: gira.inicio,
                fin: gira.fin,
                giraffinalizacion: gira.giraffinalizacion ?? gira.fin,
                insinicio: gira.insinicio,
                insfin: gira.insfin,
                importe1: gira.importe1,
                importe2: gira.importe2,
                importe3: gira.importe3,
                importe4: gira.importe4,
                importeeventual: gira.importeeventual,
                importe7: gira.importe7,
                importe8: gira.importe8,
                importewagr: gira.wagr,
                importecij: gira.cij,
                foto: gira.foto,
                lastCodigo: gira.lastcodigo,
                nacional: gira.nacional,
            }));
            return apiCache.set(CACHE_KEY, result, CACHE_TTL.LIST);
        } catch (error) {
            console.error('Error fetching data:', error);
            return { message: "No hay giras vigentes" };
        }
    },
};

export default GiraInfData;
